import React, { useState, useEffect } from 'react'
import { Parallax } from 'react-scroll-parallax'
import VisibilitySensor from 'react-visibility-sensor'
import scrollToElement from 'scroll-to-element'
import { isMobile, isMobileOnly } from 'react-device-detect'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ScrollDown from './../svg/down-arrow.svg';
import '../css/NarrativeHero.scss'

const NarrativeHero = ({ headline, body, image, desc }) => {
  const [heroVisible, setHeroVisible] = useState(false)
  const [opacity, setHeroOpacity] = useState(false)

  useEffect(() => {
    if (window.innerWidth > 1024) {
      window.addEventListener('scroll', updateHeroOpacity)
    } 
  })

  const updateHeroOpacity = e => {
    setHeroOpacity(1 - window.pageYOffset / 600);
  }

  const heroVisiblityChange = isVisible => {
    if (isVisible) {
      setHeroVisible(true)
    }
  }
  const scrollToFirstTime = e => {
    scrollToElement(`#timeline-content`, {
      offset: 5, // this is temp
      ease: 'outExpo',
      duration: 750
    })
  }
  return (
    <VisibilitySensor onChange={heroVisiblityChange} partialVisibility>
      <div className={`narrpage-hero ${heroVisible ? 'isVisible' : ''}`}>
        <div className='narrative-hero'>
          <Parallax
            disabled={true}
            className='hero-image-container fade-up'
            y={isMobile ? isMobileOnly ? [10, -10] : [25, -20] : [-20, 20]}
          >
            <div className='hero-image'>
              <div className='hero image-container' style={{ opacity }}>
                <img src={`./img/narratives/pageHero/${image}`} alt={headline} />
              </div>
            </div>
          </Parallax>
          <Parallax
            className='hero-text fade-up'
            disabled
            y={[0, -5]}
          >
            <div className='descriptive-header narrative-headline'>{desc}</div>
          </Parallax>
        </div>
        <div className='narrative-text'>
          <Container>
            <Row>
              <Col md={{ offset: 5 }} lg={{ offset: 7 }}>
                <div className={'narrative-wrapper'}>
                  <h1 className='narrative-meta-hero'>
                    {headline}
                  </h1>
                  <p className='narrative-intro'>{body}</p>
                  <div className='scroll-button' onClick={scrollToFirstTime}>
                    <img src={ScrollDown} alt={'Scroll down'}/>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </VisibilitySensor>
  )
}

export default NarrativeHero
